import { Component, createRef } from "react"

/* Moment */
import moment from "moment"

/* REST API */
import { status, remove, restore } from "../../api/Member"

/* Components */
import { Avatar, Icon } from "../../components"

/* Constants */
import { env } from "../../constants"

/* Helpers */
import { utils } from "../../helpers"

/* Widgets */
import MemberModal from "./MemberModal"

/* Shared */
import { DAYS, ROLES, line } from "./shared"

/* Widgets */
import { toast, confirm } from "../common"


/* Widget Team Tab — the team of the point. It is both looked at and managed here: the card of
   a master opens in its own window, and the page of the participants is gone */
class TeamTab extends Component {

    constructor() {
        super()

        /* The card of the master is opened by the reference */
        this._member = createRef()
    }

    /* Hand the point over to another master — the crown moves to him */
    owner = member => {

        const { data, reload } = this.props

        confirm({
            title: `Сделать владельцем ${utils.check(member.name, "участника")}?`,
            text: "Прежний владелец станет администратором точки",
            confirmText: "Да, сделать",
            cancelText: "Отмена"
        }).then(confirmed => {

            if (!confirmed) {
                return
            }

            status({ id: data.organization.id, memberID: member.memberID }).then(response => {
                if (response.status === 200) {
                    reload()
                    toast.success("Владелец изменён")
                }
                else {
                    toast.error("Что-то пошло не так! Попробуйте позднее.")
                }
            }).catch(() => {
                toast.error("Что-то пошло не так! Попробуйте позднее.")
            })
        })
    }

    /* The master leaves the team — his rows stay for the history of the point */
    remove = member => {

        const { data, reload } = this.props

        confirm({
            title: `Уволить ${utils.check(member.name, "участника")}?`,
            text: "Записи и заработок останутся в истории точки, мастер пропадёт из расписания",
            confirmText: "Да, уволить",
            cancelText: "Отмена",
            danger: true
        }).then(confirmed => {

            if (!confirmed) {
                return
            }

            remove({ id: data.organization.id, memberID: member.memberID }).then(response => {
                if (response.status === 200) {
                    reload()
                    toast.success("Участник уволен")
                }
                else {
                    toast.error("Не удалось уволить участника")
                }
            }).catch(() => {
                toast.error("Не удалось уволить участника")
            })
        })
    }

    /* The master returns to the team */
    restore = member => {

        const { data, reload } = this.props

        restore({ id: data.organization.id, memberID: member.memberID }).then(response => {
            if (response.status === 200) {
                reload()
                toast.success("Участник вернулся в команду")
            }
            else {
                toast.error("Не удалось вернуть участника")
            }
        }).catch(() => {
            toast.error("Не удалось вернуть участника")
        })
    }

    /* The schedule of one master. A master on a rotation does not work by the week at all, so
       the turn itself is shown instead of the seven rows nobody reads for him */
    _schedule = (schedule, member) => {

        /* The rotation — how long the turn is, when it started and what hours it keeps */
        if (`${member.scheduleMode}` === "cycle") {

            /* Check — a rotation which was never filled in says nothing */
            if (!parseInt(member.cycleOn)) {
                return null
            }

            /* The hours of a working day of the turn */
            const hours = member.cycleStartTime && member.cycleEndTime ? `${`${member.cycleStartTime}`.slice(0, 5)} — ${`${member.cycleEndTime}`.slice(0, 5)}` : "Часы не указаны"
            const rest = member.cycleBreakStart && member.cycleBreakEnd ? `обед ${`${member.cycleBreakStart}`.slice(0, 5)} — ${`${member.cycleBreakEnd}`.slice(0, 5)}` : ""

            return (
                <div className="organization-details-schedule">

                    <div className="organization-details-day">
                        <div className="organization-details-day-text">Цикл</div>
                        <div className="organization-details-day-time">{`${parseInt(member.cycleOn)}/${parseInt(member.cycleOff)}`}</div>
                    </div>

                    <div className="organization-details-day">
                        <div className="organization-details-day-text">С</div>
                        <div className="organization-details-day-time">{member.cycleFrom ? moment(member.cycleFrom).format("DD.MM.YYYY") : "—"}</div>
                    </div>

                    <div className="organization-details-day">
                        <div className="organization-details-day-text">Смена</div>
                        <div className="organization-details-day-time">{hours}</div>
                    </div>

                    {rest !== "" &&
                        <div className="organization-details-day">
                            <div className="organization-details-day-text">Обед</div>
                            <div className="organization-details-day-time">{`${`${member.cycleBreakStart}`.slice(0, 5)} — ${`${member.cycleBreakEnd}`.slice(0, 5)}`}</div>
                        </div>
                    }

                </div>
            )
        }

        /* Check Data */
        if (schedule.length === 0) {
            return null
        }

        return (
            <div className="organization-details-schedule">
                {DAYS.map(day => {

                    const worktime = schedule.find(item => item.day === day.day)

                    if (!worktime) {
                        return null
                    }

                    /* The hours of the day, and the lunch break which is cut out of them */
                    const off = parseInt(worktime.isDayOff) === 1
                    const rest = worktime.breakStart && worktime.breakEnd ? `${`${worktime.breakStart}`.slice(0, 5)} — ${`${worktime.breakEnd}`.slice(0, 5)}` : ""

                    return (
                        <div key={day.day} className={`organization-details-day ${off ? "off" : ""}`}>
                            <div className="organization-details-day-text">{day.text}</div>
                            <div className="organization-details-day-time">
                                {off ? "Выходной" : `${worktime.startworktime} — ${worktime.endworktime}`}
                                {!off && rest !== "" && <span className="organization-details-day-break">обед {rest}</span>}
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    render = () => {

        /* Fields */
        const { data, reload } = this.props
        const { team, worktimes } = data

        return (
            <div className="organization-details-body">

                <div className="organization-details-buttons">
                    <div onClick={() => this._member.current.open()} className="organization-details-action primary">
                        <Icon name="plus" size={15} width={2.2} />
                        <span>Добавить участника</span>
                    </div>
                </div>

                {team.length === 0 && <div className="organization-details-empty">В команде пока никого нет</div>}

                {team.map(member => {

                    /* The schedule of this master */
                    const schedule = worktimes.filter(worktime => parseInt(worktime.memberID) === parseInt(member.memberID))
                    const active = parseInt(member.active) === 1

                    return (
                        <div key={`${member.id}`} className={`organization-details-card ${active ? "" : "inactive"}`}>

                            <div className="organization-details-card-head">

                                <Avatar className="organization-details-card-avatar" src={member.image ? `${env.mediapoint}members/${member.image}` : null} alt={member.name}>
                                    <span>{`${utils.check(member.name, "?")}`.charAt(0).toUpperCase()}</span>
                                </Avatar>

                                <div className="organization-details-card-title">
                                    <div className="organization-details-card-name">
                                        {utils.check(member.name, "Без имени")}
                                        {member.role === "owner" && <span className="organization-details-crown"><Icon name="crown" size={14} width={1.9} /></span>}
                                    </div>
                                    <div className="organization-details-card-text">{utils.check(member.profession, utils.check(ROLES[member.role], member.role))}</div>
                                </div>

                                <div className="organization-details-card-tags">
                                    <div className={`tag ${member.role === "owner" ? "purple" : member.role === "admin" ? "" : "grey"}`}>{utils.check(ROLES[member.role], member.role)}</div>
                                    {active ? null : <div className="tag red">Уволен</div>}
                                </div>

                                <div className="organization-details-card-tools">

                                    <div onClick={() => this._member.current.open(member, schedule)} className="organization-details-tool" title="Изменить">
                                        <Icon name="edit" size={15} />
                                    </div>

                                    {member.role !== "owner" && active &&
                                        <div onClick={() => this.owner(member)} className="organization-details-tool" title="Сделать владельцем">
                                            <Icon name="crown" size={15} />
                                        </div>
                                    }

                                    {member.role !== "owner" && active &&
                                        <div onClick={() => this.remove(member)} className="organization-details-tool red" title="Уволить">
                                            <Icon name="trash" size={15} />
                                        </div>
                                    }

                                    {!active &&
                                        <div onClick={() => this.restore(member)} className="organization-details-tool" title="Вернуть в команду">
                                            <Icon name="refresh" size={15} />
                                        </div>
                                    }

                                </div>

                            </div>

                            <div className="organization-details-card-body">
                                {line("ID", member.memberID)}
                                {line("Token", member.token)}
                                {line("Телефон", member.phone)}
                                {line("Email", member.email)}
                                {line("Записей", member.bookings)}
                                {line("Оклад", member.salary ? utils.convertor(member.salary, "₸", 1) : "Не указан")}
                                {line("Доля с записей", `${member.share ? member.share : 0} %`)}
                                {line("В расписании", parseInt(member.inSchedule) === 1 ? "Виден клиентам" : "Скрыт")}
                                {member.role === "specialist" && line("Видит телефоны", parseInt(member.accessPhone) === 1 ? "Да" : "Нет")}
                                {member.role === "specialist" && line("Ведёт записи", parseInt(member.accessBooking) === 1 ? "Да" : "Нет")}
                                {member.role === "specialist" && line("Видит расписание команды", parseInt(member.accessSchedule) === 1 || parseInt(member.accessBooking) === 1 ? "Да" : "Только свои записи")}
                                {line("В команде с", member.createdAt ? moment(member.createdAt).format("DD.MM.YYYY") : null)}
                            </div>

                            {this._schedule(schedule, member)}

                        </div>
                    )
                })}

                {/* Draw Member */}
                <MemberModal ref={this._member} organizationID={data.organization.id} onSaved={reload} />

            </div>
        )
    }
}

export default TeamTab
